export const locale = {
  lang: "it",
  data: {
    MENU: {
      JOB_POSITIONS: "Posizioni lavorative",
      JOB_POSITIONS_CATEGORIES: "Categorie posizioni lavorative",
      ADS: "Annunci",
    },
    ALERT: {
      ERROR_JOB_CATEGORY_REMOVE: "Errore nella rimozione della categoria lavorativa.",
      SUCCESS_JOB_CATEGORY_INSERT: "Categoria posizione lavorativa aggiunta con successo.",
      ERROR_JOB_CATEGORY_INSERT: "Errore nell'inserimento della categoria posizione lavorativa.",
      SUCCESS_JOB_CATEGORY_EDIT: "Categoria posizione lavorativa modificata con successo",
      ERROR_JOB_CATEGORY_EDIT: "Errore nella rimozione della categoria lavorativa.",
      ERROR_JOB_POSITION_REMOVE: "Errore nella rimozione della posizione lavorativa.",
      SUCCESS_JOB_POSITION_INSERT: "Posizione lavorativa aggiunta con successo.",
      ERROR_JOB_POSITION_INSERT: "Errore nell'inserimento della posizione lavorativa.",
      SUCCESS_JOB_POSITION_EDIT: "Posizione lavorativa modificata con successo",
      ERROR_JOB_POSITION_EDIT: "Errore nella rimozione della posizione lavorativa.",
      ERROR_NOT_FOUND_JOB_POSITION: "Nessuna posizione lavorativa trovata.",
    },
    INSERT: {
      SELECT_JOB_CATEGORY: "Seleziona una categoria.",
      SELECT_REQUEST: "Seleziona una richiesta",
    },
    TITLES: {
      JOB_POSITIONS: "Posizioni lavorative",
    },
    ERRORS: {
      INSERT_JOB_POSITIONS_CATEGORY: "Il campo categoria posizione lavorativa è obbligatorio",
    },
    JOB_CATEGORY: "Categoria posizione lavorativa",
    JOB_CATEGORIES: "Categorie posizioni lavorative",
    SUMMARY: "Riepilogo",
    TRANSFORM_TO_CANDIDATE: "Aggiungi ai candidati",
    CANDIDATURE: "Candidature",
  },
};
